const MAX_TEXT_LENGTH = 512;
const MAX_URL_LENGTH = 2048;
const CONTROL_CHARS = /[\u0000-\u001F\u007F]/u;
const HTML_TAG_PATTERN = /<\s*\/?\s*[a-z][^>]*>/i;
const SUSPECT_ENCODED = /%3C|%3E|%27|%22|%28|%29/i;
const ALLOWED_TEXT = /^[\w\s\-.,:_=|@+]*$/u;
export function isSafeTicket(value, maxLength = MAX_TEXT_LENGTH) {
    if (!value)
        return true;
    if (value.length > maxLength)
        return false;
    return true;
}
export function isSafeText(value, allowed = ALLOWED_TEXT, maxLength = MAX_TEXT_LENGTH) {
    if (!value)
        return true;
    if (value.length > maxLength)
        return false;
    if (CONTROL_CHARS.test(value))
        return false;
    if (HTML_TAG_PATTERN.test(value))
        return false;
    if (SUSPECT_ENCODED.test(value))
        return false;
    return allowed.test(value);
}
export function isSafeUrl(value, opts = {}) {
    if (!value)
        return false;
    const { allowedProtocols = process.env.MODE === "development" ? ["http:", "https:"] : ["https:"], allowRelative = false, maxLength = MAX_URL_LENGTH } = opts;
    if (value.length > maxLength)
        return false;
    if (CONTROL_CHARS.test(value))
        return false;
    if (SUSPECT_ENCODED.test(value))
        return false;
    try {
        const url = new URL(value, window.location.href);
        if (!allowedProtocols.includes(url.protocol)) {
            if (allowRelative && !value.match(/^[a-zA-Z][a-zA-Z0-9+.-]*:/)) {
                return true;
            }
            return false;
        }
        const combined = `${url.pathname}${url.search}${url.hash}`;
        if (/[\r\n]/.test(combined))
            return false;
        return true;
    }
    catch (_a) {
        if (!allowRelative)
            return false;
        if (HTML_TAG_PATTERN.test(value))
            return false;
        const REL_ALLOWED = /^[/.\w\-~@%+?=&:#]*$/u;
        return REL_ALLOWED.test(value);
    }
}
export function isSafeNavigationParam(value) {
    if (value === "") {
        return true;
    }
    if (isSafeUrl(value)) {
        return true;
    }
    const prefix = "action:";
    if (!value.startsWith(prefix)) {
        return false;
    }
    if (isSafeText(value, /^[\w\s\-.,:_=|/@+]*$/u)) {
        return true;
    }
    const target = value.slice(prefix.length);
    return isSafeUrl(target);
}
export function getSafeParam(source, name, validator) {
    const raw = source.get(name);
    if (raw == null) {
        return null;
    }
    const normalized = raw.trim();
    validator = validator !== null && validator !== void 0 ? validator : isSafeText;
    if (!validator(normalized)) {
        return null;
    }
    return normalized;
}
